import { useDispatch, useSelector } from 'react-redux';

// @mui/material components
import { makeStyles, withStyles } from '@mui/styles';

// material ui icons
import EmojiFlagsIcon from '@mui/icons-material/EmojiFlags';

import Table from 'components/Table/Table';

// core components
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';

import CardBody from 'components/Card/CardBody';
import CardIcon from 'components/Card/CardIcon';

// style for this view
import styles from 'assets/jss/material-dashboard-pro-react/views/clientEditStyle';

// Redux
import { selectCurrentClient } from '@features/client/clientSlice';
import {
  selectFeatureLibrary,
  updateFeatureLibrary,
} from '@features/featureLibrary/featureLibrarySlice';
import { selectNtAdministrator } from '@features/user/userSlice';
import Switch from '@mui/material/Switch';
import {
  primaryColor,
  secondaryColor,
  whiteColor,
} from '@themes/defaultThemeProps';

const useStyles = makeStyles(styles);

const FeatureLibrary = (props) => {
  const { classes } = props;
  const dispatch = useDispatch();
  const ntAdministration = useSelector(selectNtAdministrator);
  const features = useSelector(selectFeatureLibrary);
  const currentClient = useSelector(selectCurrentClient);

  const handleToggle = (value, key) => {
    dispatch(
      updateFeatureLibrary({
        key: key,
        client_id: currentClient._id,
        enabled: value,
      })
    );
  };

  const featureRows = () => {
    const featureList = features.map((feature, key) => {
      let cols = [];
      cols.push(feature.name);
      cols.push(feature.description);
      cols.push(
        <div className={classes.switchContainer}>
          <span>False</span>
          <AntSwitch
            key={key}
            id='booleanValue'
            label='booleanValue'
            checked={feature.enabled}
            onChange={(e) => handleToggle(e.target.checked, feature.key)}
          />
          <span>True</span>
        </div>
      );
      return cols;
    });
    return featureList;
  };

  const AntSwitch = withStyles(() => ({
    root: {
      width: 28,
      height: 16,
      padding: 0,
      display: 'flex',
    },
    switchBase: {
      padding: 2,
      color: secondaryColor[1],
      '&$checked': {
        transform: 'translateX(12px)',
        color: whiteColor,
        '& + $track': {
          opacity: 1,
          backgroundColor: primaryColor[0],
          borderColor: primaryColor[0],
        },
      },
    },
    thumb: {
      width: 12,
      height: 12,
      boxShadow: 'none',
    },
    track: {
      border: `1px solid ${primaryColor[0]}`,
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: whiteColor,
    },
    checked: {},
  }))(Switch);

  return (
    <>
      {ntAdministration ? (
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardHeader color='rose' icon>
                <CardIcon color='rose'>
                  <EmojiFlagsIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Feature Flags</h4>
              </CardHeader>
              <CardBody>
                <Table
                  key='y8931207837'
                  tableHead={['Feature', 'Description', 'Enabled for company']}
                  tableData={featureRows()}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      ) : null}
    </>
  );
};

export default withStyles(styles)(FeatureLibrary);
